import { useTranslation } from 'react-i18next';
import { useGetNumbersOnlyRule, useGetRequiredRule } from '@/hooks';
import { EditCategoryFieldNames } from '../helpers/types';

export const useCreateCategoryValidationRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const numbersOnlyRule = useGetNumbersOnlyRule({ t });

  return {
    [EditCategoryFieldNames.LOCALE]: [requiredRule],
    [EditCategoryFieldNames.GOOGLE_FEED_ID]: [requiredRule, numbersOnlyRule],
  };
};
